export const newDateWithEmptyTime = (dateStr?: string) => {
  const newDate = dateStr ? new Date(dateStr) : new Date();
  newDate.setHours(0, 0, 0, 0);

  return newDate;
};
